// Branded, multi-page "AI Governance Board Pack" generated client-side (careful, non-legal wording).
const PAGE = { w: 595.28, h: 841.89 };
const M = 46;
const CW = PAGE.w - M * 2;
const NAVY = [5, 7, 15];
const CYAN = [56, 217, 240];
const CYAN_T = [13, 110, 138];
const INK = [28, 32, 40];
const MUTED = [110, 120, 135];

const SECTIONS = [
  ["The enterprise AI risk landscape", "Generative AI is now used across customer, employee and operational workflows. This creates new exposure: sensitive data leaving the organisation, unsuitable or non-compliant outputs, prompt injection, and autonomous agent actions. Governance needs to operate at the point of interaction, not only in policy documents."],
  ["A governance architecture", "An independent control layer sits between users, AI systems and business workflows. It inspects inputs and outputs, applies organisation-defined policies, intervenes before release where configured, and routes material cases to people — producing a reviewable record throughout."],
  ["Human accountability", "AI does not make the final regulatory decision. Escalation routes and named reviewers keep meaningful human oversight, and management retains accountability for outcomes."],
  ["Policy controls", "Policies are versioned and organisation-defined. They can differ by role, channel and jurisdiction, and map to actions such as allow, warn, redact, block, hold or escalate."],
  ["Data handling", "Configurable inspection, redaction and retention. Sensitive information can be detected and minimised, with only a minimal evidence reference retained where appropriate."],
  ["Deployment options", "Hosted, private cloud or customer-controlled environments, chosen against sensitivity, data residency and integration requirements."],
  ["Regulatory mapping", "Governance themes can be mapped to operational controls and evidence. Mappings should be validated against the organisation's own regulatory and legal requirements."],
  ["Incident management", "Detected risks become recorded incidents: triaged, routed to reviewers, resolved and evidenced with a linked timeline."],
  ["Audit & evidence model", "Each handled interaction can produce a reviewable, time-stamped record linking the event, policy, action and decision — supporting internal review and management information."],
  ["Implementation process", "Typical path: discovery of AI use and risk, policy configuration, integration and deployment, monitoring, and continuous review."],
  ["Questions boards should ask management", "Where is AI used, and what could go wrong? Which controls operate at the point of interaction? Who reviews escalations? Can we evidence what happened after an incident? How is this reported to the board?"],
];

function drawBand(doc, sub) {
  doc.setFillColor(...NAVY); doc.rect(0, 0, PAGE.w, 96, "F");
  doc.setFillColor(...CYAN); doc.rect(0, 96, PAGE.w, 3, "F");
  doc.setFont("helvetica", "bold"); doc.setTextColor(255, 255, 255); doc.setFontSize(22);
  doc.text("norse3", M, 44);
  doc.setFontSize(15); doc.setTextColor(150, 220, 238);
  doc.text("AI Governance Board Pack", M, 68);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(150, 160, 175);
  doc.text(sub, M, 86);
}

function footer(doc) {
  const n = doc.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(...MUTED);
    doc.text("Educational only \u2014 not legal, regulatory or compliance advice. Your firm remains accountable.", M, PAGE.h - 24, { maxWidth: CW - 60 });
    doc.text(`${i} / ${n}`, PAGE.w - M, PAGE.h - 24, { align: "right" });
  }
}

export async function generateBoardPack({ name, company } = {}) {
  const { jsPDF } = await import("jspdf");
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  drawBand(doc, "Building the business case for controlled enterprise AI");
  let y = 128;
  doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...INK);
  if (company || name) {
    doc.text(`Prepared for ${[name, company].filter(Boolean).join(", ")}`, M, y); y += 22;
  }
  doc.setFontSize(10); doc.setTextColor(...MUTED);
  y += doc.splitTextToSize("A concise pack to help leadership frame controlled adoption of enterprise AI: the risks, the architecture, human accountability, and the questions a board should ask.", CW).length * 13;
  doc.text(doc.splitTextToSize("A concise pack to help leadership frame controlled adoption of enterprise AI: the risks, the architecture, human accountability, and the questions a board should ask.", CW), M, 150);
  y = 150 + 60;

  SECTIONS.forEach(([title, body], idx) => {
    const bodyLines = doc.splitTextToSize(body, CW);
    const need = 26 + bodyLines.length * 13 + 18;
    if (y + need > PAGE.h - 60) { doc.addPage(); y = 60; }
    doc.setFillColor(...CYAN); doc.rect(M, y - 9, 3, 13, "F");
    doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(...CYAN_T);
    doc.text(`${String(idx + 1).padStart(2, "0")}  ${title}`, M + 10, y); y += 20;
    doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...INK);
    doc.text(bodyLines, M, y); y += bodyLines.length * 13 + 20;
  });

  footer(doc);
  doc.save("norse3-ai-governance-board-pack.pdf");
}
